import { FC, PropsWithChildren, Suspense } from 'react';
import { NavPanel } from './NavPanel';
import { Layout as AntdLayout } from 'antd';
import classes from './Layout.module.scss';
import { Content, Header } from 'antd/lib/layout/layout';
import { Loader } from '@/components';

export const Layout: FC<PropsWithChildren<{}>> = ({ children }) => {
  return (
    <AntdLayout className={classes.layout}>
      <Header className={classes.header}>
        <NavPanel />
      </Header>
      <Content className={classes.main}>
        <Suspense fallback={<Loader />}>{children}</Suspense>
      </Content>
    </AntdLayout>
  );
};
